var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.ticket
        ? _c(
            "sui-form",
            [
              _c(
                "sui-grid",
                [
                  _c(
                    "sui-grid-row",
                    [
                      _c(
                        "sui-grid-column",
                        { attrs: { width: 8 } },
                        [
                          _c(
                            "sui-form-field",
                            { attrs: { required: "" } },
                            [
                              _c("label", [_vm._v("Category")]),
                              _c("sui-dropdown", {
                                attrs: {
                                  placeholder: "Category",
                                  selection: "",
                                  direction: "downward",
                                  options: _vm.ticketCategoryOptions,
                                },
                                model: {
                                  value: _vm.supportTicket.Category__c,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.supportTicket,
                                      "Category__c",
                                      $$v
                                    )
                                  },
                                  expression: "supportTicket.Category__c",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "sui-form-field",
                            [
                              _c("label", [_vm._v("Priority")]),
                              _c("sui-dropdown", {
                                attrs: {
                                  placeholder: "Priority",
                                  selection: "",
                                  direction: "downward",
                                  options: _vm.ticketPriorityOptions,
                                },
                                model: {
                                  value: _vm.supportTicket.Priority,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supportTicket, "Priority", $$v)
                                  },
                                  expression: "supportTicket.Priority",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "sui-grid-column",
                        { attrs: { width: 8 } },
                        [
                          _c(
                            "sui-form-field",
                            [
                              _c("label", [_vm._v("Category Type")]),
                              _c("sui-dropdown", {
                                attrs: {
                                  placeholder: "Category Type",
                                  selection: "",
                                  direction: "downward",
                                  options: _vm.ticketTypeOptions,
                                },
                                model: {
                                  value: _vm.supportTicket.Type,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supportTicket, "Type", $$v)
                                  },
                                  expression: "supportTicket.Type",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "sui-form-field",
                            [
                              _c("label", [_vm._v("Reason")]),
                              _c("sui-dropdown", {
                                attrs: {
                                  placeholder: "Reason",
                                  selection: "",
                                  direction: "downward",
                                  options: _vm.ticketReasonOptions,
                                },
                                model: {
                                  value: _vm.supportTicket.Reason,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supportTicket, "Reason", $$v)
                                  },
                                  expression: "supportTicket.Reason",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "sui-form-field",
                            { attrs: { disabled: "" } },
                            [
                              _c("label", [_vm._v("Status")]),
                              _c("sui-dropdown", {
                                attrs: {
                                  placeholder: "Status",
                                  selection: "",
                                  direction: "downward",
                                  options: _vm.ticketStatusOptions,
                                },
                                model: {
                                  value: _vm.supportTicket.Status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.supportTicket, "Status", $$v)
                                  },
                                  expression: "supportTicket.Status",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "sui-grid-row",
                    [
                      _c(
                        "sui-grid-column",
                        [
                          _c("sui-form-field", { attrs: { required: "" } }, [
                            _c("label", [_vm._v("Subject")]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.supportTicket.Subject,
                                  expression: "supportTicket.Subject",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "subject",
                                placeholder: "Subject",
                              },
                              domProps: { value: _vm.supportTicket.Subject },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.supportTicket,
                                    "Subject",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "sui-grid-row",
                    [
                      _c(
                        "sui-grid-column",
                        [
                          _c("sui-form-field", [
                            _c("label", [_vm._v("Description")]),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.supportTicket.Description,
                                  expression: "supportTicket.Description",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "description",
                                rows: "10",
                              },
                              domProps: {
                                value: _vm.supportTicket.Description,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.supportTicket,
                                    "Description",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }